<template>
  <div>
    <div class="title">
      <el-select
        v-model="area_id"
        class="wid_l"
        @change="seChange()"
        placeholder="请选择"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <p @click="getFullCreeen">🐉数据监控大屏🌈</p>
    </div>
    <div class="top-div">
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="new_orders" class="svg-class"/>
            <div class="content-info">今日订单</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.new_order.new_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.new_order.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.new_order.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.new_order.diff == '3' " icon-class="upup" class="down"/>
              {{ top.new_order.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="profit" class="svg-class"/>
            <div class="content-info">今日收益</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_profit.today_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_profit.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_profit.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_profit.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_profit.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="many_people" class="svg-class"/>
            <div class="content-info">总用户</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_user.total_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_user.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_user.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_user.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_user.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="total_orders" class="svg-class"/>
            <div class="content-info">总订单</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_order.total_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_order.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_order.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_order.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_order.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="diandongche" class="svg-class"/>
            <div class="content-info">总投放车辆</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_put_bikes }}</span>
            <!-- <div class="change-num">
                                      <span class="card-panel-change-text">同比昨日</span>
                                      <svg-icon v-show="top.total_profit.diff == '1' " icon-class="down" class="down"/>
                                      <svg-icon v-show="top.total_profit.diff == '2' " icon-class="level" class="down"/>
                                      <svg-icon v-show="top.total_profit.diff == '3' " icon-class="upup" class="down"/> {{ top.total_profit.difference }}
                                    </div> -->
          </div>
        </div>
      </el-card>
    </div>
    <div class="mid">
      <div class="last_item left_item">
        <el-card>
          <!-- <span class="todo-title">本日新增日租订单趋势</span>
                              <el-row style="background:#fff;padding:16px 16px 0;">
                                <line-chart :chart-data="orderRentChart" width="95%"/>
                              </el-row> -->
          <span class="todo-title">待办事项</span>
          <div class="todo-event">
            <el-card class="todo-top fi">
              <div class="todo-ma-top">
                <p>{{ todo_event.long_time_no_ridding }}</p><span>24h未骑车辆</span>
              </div>
            </el-card>
            <el-card class="todo-top">
              <div class="todo-ma-top">
                <p>{{ todo_event.long_time_no_return_ridding }}</p>
                <span>24h未还车辆</span>
              </div>
            </el-card>
            <el-card class="todo-bo fi">
              <div class="todo-ma-top">
                <p class="red-class">{{ todo_event.trouble_num }}</p>
                <span>故障车辆</span>
              </div>
            </el-card>
            <el-card class="todo-bo fi">
              <div class="todo-ma-top">
                <p class="red-class">{{ todo_event.low_battery_num }}</p><span>低电车辆</span>
              </div>
            </el-card>
            <el-card class="todo-bo">
              <div class="todo-ma-top">
                <p class="red-class">{{ todo_event.warning_num }}</p>
                <span>报警信息</span>
              </div>
            </el-card>
          </div>
        </el-card>
        <el-card class="second">
          <span class="todo-title">近30日活跃用户分析</span>
          <el-row style="background:#fff;padding:16px 16px 0;">
            <pie-chart :chart-data="activeUserAgePieChart" width="95%"/>
            <pie-chart :chart-data="activeUserGendersPieChart" width="95%"/>
          </el-row>
        </el-card>
      </div>
      <div class="mapmap">
        <div class="map">
          <el-amap
            vid="amap"
            :plugin="plugin"
            class="amap-demo"
            :center="center"
            :default-cursor="defaultCursor"
            :zoom="zoom"
            :amap-manager="amapManager"
            :events="events"
          />
          <div class="map-heatmap-button-container">
            <el-button-group>
              <el-button
                size="mini"
                plain
                type="primary"
                @click="changeHeatmap('start')"
              >
                扫码热力图
              </el-button>
              <el-button
                size="mini"
                plain
                type="primary"
                @click="changeHeatmap('end')"
              >
                停车热力图
              </el-button>
            </el-button-group>
          </div>
          <div class="map-edit-container">
            <div class="map-edit-item">
              <div>
                <img src="@/assets/bikesInfo/low.29a1bda.png" alt="低电量">
              </div>
              <div>
                <span class="span-cs">低电量</span>
                <span class="color-span">{{ low_power_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img src="@/assets/bikesInfo/using.172bef6.png" alt="使用中">
              </div>
              <div>
                <span class="span-cs">使用中</span>
                <span class="color-span">{{ riding_yes_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img src="@/assets/bikesInfo/unuse.38fefdf.png" alt="未使用">
              </div>
              <div>
                <span class="span-cs">未使用</span>
                <span class="color-span">{{ riding_no_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img
                    src="http://resource.bike.hanyiyun.com/work_riding.png"
                    alt="运维使用"
                >
              </div>
              <div>
                <span class="span-cs">运维用</span>
                <span class="color-span">{{ worker_riding_num }}</span>
              </div>
            </div>
          </div>
          </el-amap>
        </div>
        <div class="last_div">
          <el-card class="last_item">
            <span class="todo-title">近月订单收益</span>
            <el-row style="background:#fff;">
              <line-chart :chart-data="MonthOrderProfitChartData" width="95%" height="220px"/>
            </el-row>
          </el-card>
          <el-card class="last_item left_item">
            <span class="todo-title">近月新增用户</span>
            <el-row style="background:#fff;">
              <line-chart :chart-data="MonthAddUserChartData" width="95%" height="220px"/>
            </el-row>
          </el-card>
        </div>
      </div>

      <div class="chart">
        <el-card>
          <span class="todo-title">日新增订单趋势</span>
          <el-row style="background:#fff;">
            <many-bar-chart :chart-data="newOrderChartData" height="380px"/>
          </el-row>
        </el-card>
        <el-card class="second">
          <span class="todo-title">近七日新订单</span>
          <el-row style="background:#fff;">
            <line-chart :chart-data="weekNewOrderChartData" width="95%" height="380px"/>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTopIndex, getNewUsersChart, getNewOrderChart,
  getProfitChart, getTodoEvent, getHeatMapData, getNewDayRentOrderChart,
  getMapBikes, getAreas, getHourOrderNumber, getRecentMonthOrderProfit,
  acticveWxUserSattistics, getRecentMonthAddUser, getBikeStatisticsOpen,
} from '@/api/indexOpen'
import LineChart from './components/LineChart'
import LineChartWeek from './components/LineChartWeek'
import BarChart from './components/BarChart'
import PieChart from './components/PieChart'
import ManyBarChart from './components/ManyBarChart'
import VueAMap from 'vue-amap'

export default {
  name: 'Index',
  components: {
    LineChart,
    LineChartWeek,
    BarChart,
    PieChart,
    ManyBarChart,
  },
  data() {
    let self = this
    let amapManager = new VueAMap.AMapManager()
    return {
      options: [{
        value: '',
        label: '全部区域',
      }],
      area_id: '',
      top: {
        new_order: {
          new_num: 0, // 新订单数量
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_user: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_order: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_profit: {
          total_num: 0,
          today_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_put_bikes: 0,
      },
      todo_event: {
        low_battery_num: 0, // 低电量
        long_time_no_ridding: 0, // 24小时未骑车辆
        long_time_no_return_ridding: 0, // 24小时未还车
        trouble_num: 0, // 故障车辆
        warning_num: 0, // 报警数量
      },
      riding_yes_num: '',
      riding_no_num: '',
      low_power_num: '',
      worker_riding_num: '',
      center: [121.59996, 31.197646],
      defaultCursor: 'pointer',
      zoom: 12,
      lng: 0,
      lat: 0,
      loaded: false,
      points: [],
      amapManager: amapManager,
      events: {
        init(o) {
        },
      },
      mouseTool: null,
      plugin: [
        {
          pName: 'Geolocation',
          showMarker: false,
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                self.lng = 113.73350255780726
                self.lat = 34.78024666564106
                self.center = [self.lng, self.lat]
                self.loaded = true
                if (result && result.position) {
                  // console.log(result.position)
                  self.lng = result.position.lng
                  self.lat = result.position.lat
                  self.center = [self.lng, self.lat]
                  self.loaded = true
                  self.$nextTick()
                }
              })
            },
          },
        },
        {
          pName: 'Scale',
          // offset: { x: 1, y: 1 },
          position: 'RB',
          events: {
            init(instance) {
              // console.log(instance)
            },
          },
        },
        {
          pName: 'ToolBar',
          events: {
            init(instance) {
              // console.log(instance)
            },
          },
        },
      ],

      newUsersChart: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      orderRentChart: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      newOrderChartData: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      weekProfitChart: {
        expectedData: {
          dataName: [],
          yData: [],
        },
      },
      activeUserAgePieChart: {
        expectedData: {
          title: '年龄比例',
          data: [],
        },
      },
      activeUserGendersPieChart: {
        expectedData: {
          title: '性别比例',
          data: [],
        },
      },
      weekNewOrderChartData: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      MonthOrderProfitChartData: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      MonthAddUserChartData: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      oldMsaaMarks: '',
      oldHeatmap: null,
      heatmapDatas: null,
      n: 0,
    }
  },

  destroyed() {
    clearInterval(this.myInterval)
  },
  async created() {
    const [{ data: areas }] = await Promise.all([
      getAreas({ all: 1 }),
    ])
    areas.map(i => {
      this.options.push({ value: i.id, label: i.name })
    })
    this.initData()

    // 定时器  定时请求刷新数据
    // this.myInterval = window.setInterval(() => {
    //   setTimeout(() => {
    //     // this.newOrderChartChange('today') // 调用接口的方法
    //     // this.newUsersChartChange('today') // 调用接口的方法
    //     this.profitChartChange('today') //
    //   }, 1)
    // }, 1500000)
  },
  methods: {
    getFullCreeen() {
      this.n++
      this.n % 2 == 0
        ? this.outFullCreeen(document) : this.inFullCreeen(document.documentElement)
    },
    inFullCreeen(element) {
      let el = element
      let rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
                    el.mozRequestFullScreen || el.msRequestFullScreen
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    outFullCreeen(element) {
      let el = element
      let cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
                    el.mozCancelFullScreen || el.exitFullScreen
      if (typeof cfs !== 'undefined' && cfs) {
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    seChange() {
      var params = {}
      if (this.area_id !== '') {
        params = { area_id: this.area_id }
      }
      this.initData(params)
    },
    async initData(params = {}) {
      // 头部统计
      const [{ data: top }] = await Promise.all([
        getTopIndex(params),
      ])
      this.top = top

      // 待办事项统计
      const [{ data: todoEvent }] = await Promise.all([
        getTodoEvent(params),
      ])
      this.todo_event = todoEvent
      // 地图车辆统计
      const [{ data: statistics }] = await Promise.all([

        getBikeStatisticsOpen(params),
      ])

      this.low_power_num = statistics.low_power_num
      this.riding_yes_num = statistics.riding_yes_num
      this.riding_no_num = statistics.riding_no_num
      this.worker_riding_num = statistics.worker_riding_num
      // 新增用户折线图
      // const [{ data: newUserChart }] = await Promise.all([
      //   getNewUsersChart({ days: 'today' }),
      // ])
      // newUserChart.map(i => {
      //   this.newUsersChart.expectedData.data.push(i.value) // 统计得押金
      //   this.newUsersChart.expectedData.date.push(i.date)
      // })
      var dayParams = { days: 'today' }
      // 总收益折线图  今日
      if (params !== {}) {
        dayParams = { days: 'today', area_id: params.area_id }
      }
      const [{ data: orderRentChart }] = await Promise.all([
        getNewDayRentOrderChart(dayParams),
      ])
      this.orderRentChart.expectedData.data = []
      this.orderRentChart.expectedData.date = []
      orderRentChart.map(i => {
        this.orderRentChart.expectedData.data.push(i.value) //
        this.orderRentChart.expectedData.date.push(i.date)
      })

      // 新订单折线图 今日
      const [{ data: newOrderChart }] = await Promise.all([
        getHourOrderNumber(params),
      ])
      this.newOrderChartData.expectedData.data = []
      this.newOrderChartData.expectedData.date = []
      this.newOrderChartData.expectedData.data = newOrderChart.data
      this.newOrderChartData.expectedData.date = newOrderChart.date
      // 近一个月统计图
      const [{ data: monthOrderProfits }] = await Promise.all([
        getRecentMonthOrderProfit(params),
      ])
      this.MonthOrderProfitChartData.expectedData.data = []
      this.MonthOrderProfitChartData.expectedData.date = []
      monthOrderProfits.map(i => {
        this.MonthOrderProfitChartData.expectedData.data.push(i.value) //
        this.MonthOrderProfitChartData.expectedData.date.push(i.dateWeek)
      })
      // 近一个月新增用户 MonthAddUserChartData
      const [{ data: monthAddUsers }] = await Promise.all([
        getRecentMonthAddUser(params),
      ])
      this.MonthAddUserChartData.expectedData.data = []
      this.MonthAddUserChartData.expectedData.date = []
      monthAddUsers.map(i => {
        this.MonthAddUserChartData.expectedData.data.push(i.value) //
        this.MonthAddUserChartData.expectedData.date.push(i.dateWeek)
      })

      var sedayParams = { days: 'sevenDays' }
      // 总收益折线图  今日
      if (params !== {}) {
        sedayParams = { days: 'sevenDays', area_id: params.area_id }
      }
      // 总收益折线图  本周
      const [{ data: weekprofitChart }] = await Promise.all([
        getProfitChart(sedayParams),
      ])
      // 活跃用户
      const [{ data: activeUser }] = await Promise.all([
        acticveWxUserSattistics(),
      ])
      this.weekProfitChart.expectedData.yData = []
      this.weekProfitChart.expectedData.dataName = []
      this.activeUserAgePieChart.expectedData.data = activeUser.ages
      this.activeUserGendersPieChart.expectedData.data = activeUser.genders
      // console.log(this.weekProfitChart)
      // activeUser.map(i => {
      //   this.weekProfitChart.expectedData.yData.push(i.value)
      //   this.weekProfitChart.expectedData.dataName.push(i.name)
      // })

      // 新订单折线图 本周
      const [{ data: weeknewOrderChart }] = await Promise.all([
        getNewOrderChart(sedayParams),
      ])
      this.weekNewOrderChartData.expectedData.data = []
      this.weekNewOrderChartData.expectedData.date = []
      weeknewOrderChart.map(i => {
        this.weekNewOrderChartData.expectedData.data.push(i.value) //
        this.weekNewOrderChartData.expectedData.date.push(i.date)
      })

      // 地图热力图

      if (this.oldHeatmap != null) {
        // 清除老数据
        this.oldHeatmap.setMap(null)
      }
      var heatmap = new AMap.Heatmap(this.amapManager._map, {
        radius: 25, // 给定半径
        opacity: [0, 0.8],
        /*,
                                      gradient:{
                                          0.5: 'blue',
                                          0.65: 'rgb(117,211,248)',
                                          0.7: 'rgb(0, 255, 0)',
                                          0.9: '#ffea00',
                                          1.0: 'red'
                                      }
                                       */
      })
      // 设置数据集：该数据为北京部分“公园”数据
      const [{ data: heatmapData }] = await Promise.all([
        getHeatMapData(params),
      ])
      this.heatmapDatas = heatmapData
      heatmap.setDataSet({
        data: heatmapData.start,
        max: 100,
      })
      this.oldHeatmap = heatmap

      // 车辆 海量点
      let _this = this
      const {
        data: bikesMap,
      } = await getMapBikes(params)
      // 创建样式对象
      var styleObjectArr = [{
          url: 'http://resource.bike.hanyiyun.com/common/low-power.admin.png', // 图标地址 低电量
          size: new AMap.Size(25, 35), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }, {
          url: 'http://resource.bike.hanyiyun.com/common/unuse.admin.png', // 图标地址  未使用
          size: new AMap.Size(25, 35), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }, {
          url: 'http://resource.bike.hanyiyun.com/common/using.admin.png', // 图标地址  使用中
          size: new AMap.Size(25, 35), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }]
      // 清除老数据
      if (_this.oldMsaaMarks !== '') {
        _this.oldMsaaMarks.clear()
      }

      var massMarks = new AMap.MassMarks(bikesMap, {
        zIndex: 5, // 海量点图层叠加的顺序
        zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
        style: styleObjectArr, // 设置样式对象
      })

      massMarks.on('mousedown', function (e) {
        _this.pointClick(e.data.id)
      })
      massMarks.setMap(this.amapManager._map)
      _this.oldMsaaMarks = massMarks
    },
    // async newOrderChartChange(day) {
    //   // 新订单折线图 今日
    //   const [{ data: newOrderChart }] = await Promise.all([
    //     getHourOrderNumber(),
    //   ])
    //   this.newOrderChartData.expectedData.data = []
    //   this.newOrderChartData.expectedData.date = []
    //   this.newOrderChartData.expectedData.data = newOrderChart.data
    //   this.newOrderChartData.expectedData.date = newOrderChart.date
    // },
    async newUsersChartChange(day) {
      this.newUsersChart.expectedData.data = []
      this.newUsersChart.expectedData.date = []
      const [{ data: newUsersChart }] = await Promise.all([
        getNewUsersChart({ days: day }),
      ])
      newUsersChart.map(i => {
        this.newUsersChart.expectedData.data.push(i.value) // 用户增长
        this.newUsersChart.expectedData.date.push(i.date)
      })
    },
    async profitChartChange(day) {
      this.profitChart.expectedData.data = []
      this.profitChart.expectedData.date = []
      const [{ data: profitChart }] = await Promise.all([
        getProfitChart({ days: day }),
      ])
      profitChart.map(i => {
        this.profitChart.expectedData.data.push(i.value) // 统计得押金
        this.profitChart.expectedData.date.push(i.date)
      })
    },
    async changeHeatmap(param) {
      var params = {}
      if (this.area_id !== '') {
        params = { area_id: this.area_id }
      }
      if (this.oldHeatmap != null) {
        // 清除老数据
        this.oldHeatmap.setMap(null)
      }
      var heatmap = new AMap.Heatmap(this.amapManager._map, {
        radius: 25, // 给定半径
        opacity: [0, 0.8],
        /*,
                                      gradient:{
                                          0.5: 'blue',
                                          0.65: 'rgb(117,211,248)',
                                          0.7: 'rgb(0, 255, 0)',
                                          0.9: '#ffea00',
                                          1.0: 'red'
                                      }
                                       */
      })
      // 设置数据集：该数据为北京部分“公园”数据

      // const [{ data: datas }] = await Promise.all([
      //   getHeatMapData(params),
      // ])
      var heatmapData = []
      if (param == 'start') {
        heatmapData = this.heatmapDatas.start
      } else if (param == 'end') {
        heatmapData = this.heatmapDatas.end
      }
      heatmap.setDataSet({
        data: heatmapData,
        max: 100,
      })
      this.oldHeatmap = heatmap
    },
  },
}
</script>

<style lang="scss" scope>

    .title {
        display: flex;
        justify-content: space-between;
        .wid_l {
            width: 200px;
            margin: 10px 0 0 10px;
        }
        p {
            margin-top: 0px;
            margin-right: 35%;
            width: 30%;
            height: 50px;
            border: #6f7180 solid;
            border-top: none;
            border-radius: 25px;
            text-align: center;
            font-size: 36px;
        }
    }

    .top {
        display: flex;
        justify-content: space-between;
        height: 100px;
    }

    .top-div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 2px 20px;
        .top-card {
            width: 18%;
            height: 108px;
            font-size: 12px;
            color: #666;
            .top-info1 {
                display: flex;
                justify-content: space-between;
                .svg-position {
                    padding-left: 10px;
                    .svg-class {
                        width: 45px;
                        height: 45px;
                    }
                }
                .content-info {
                    text-align: center;
                    line-height: 18px;
                    color: rgba(50, 50, 50, .9);
                    font-size: 17px;
                    margin-top: 12px;
                }
                .top-item-info1 {

                    span {
                        display: block;
                        text-align: right;
                        font-weight: 700;
                        font-size: 28px;
                    }

                    .card-panel-change-text {
                        display: inline;
                        font-size: .8rem;
                        margin-right: 5px;
                        left: -80px;
                        top: 3px;
                    }
                    .change-num {
                        float: right;
                        text-align: right;
                        margin-top: 15px;
                        font-size: 16px;
                        display: inline-block;
                    }
                }
            }
        }
    }

    .mid {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .last_item {
            width: 18%;
            // margin-left: 10px;
            .todo-title {
                color: #36a3f7;
                font-size: 1.2rem;
            }
            .todo-event {
                display: flex;
                padding: 30px 20px 10px 10px;
                flex-wrap: wrap;
                height: 325px;
                width: 100%;
                .todo-top {
                    height: 145px;
                    width: 45%;
                    .todo-ma-top {
                        margin-top: 10px;
                        text-align: center;
                        span {
                            color: #6f7180;
                            font-size: 1.1rem;
                        }
                    }
                    p {
                        text-align: center;
                        font-size: 1.8rem;
                        margin: 5px auto,
                    }

                }
                .fi {
                    margin-right: 20px;
                }
                .todo-bo {
                    width: 26%;
                    // height: 145px;
                    margin-top: 10px;

                    .todo-ma-top {
                        margin-top: 10px;
                        text-align: center;

                        span {
                            color: #6f7180;
                            font-size: 1.1rem;
                        }
                    }

                    p {
                        text-align: center;
                        font-size: 1.8rem;
                        margin: 5px auto;
                    }

                }

                .red-class {
                    color: red;
                }

                .last_c {
                    margin-right: 30px;
                }

            }

            .second {
                margin-top: 30px;
            }
        }
         .left_item{
                margin-left: 10px;
            }
        .chart {
            width: 30%;
            margin-right: 10px;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: space-between;
            .second {
                margin-top: 30px;
            }
            .todo-title {
                color: #36a3f7;
                font-size: 1.2rem;
                // padding-top: 15px;
            }
            .el-card__body {
                padding: 10px !important;
            }
        }
        .mapmap {
            width: 50%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .map {
                width: 100%;
                height: 600px;
                border: rgb(19, 147, 221) solid;
                border-radius: 25px;
                overflow: hidden;
                position: relative;
                .map-heatmap-button-container{
                   margin: 0;
                    border-radius: 0.25rem;
                    position: absolute;
                    top: 28px;
                    width: 200px;
                    /* min-width: 2rem; */
                    border-width: 0px;
                    right: 350px;
                }
                .map-edit-container {
                    margin: 0;
                    border-radius: 0.25rem;
                    position: absolute;
                    top: 20px;
                    width: 300px;
                    /* min-width: 2rem; */
                    border-width: 0px;
                    right: 20px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    background: white;
                    // border:1px solid #000;
                    .map-edit-item {
                        padding: 5px 10px 2px 5px;
                        display: -webkit-box;
                        // display: flex;
                        justify-content: space-between;
                        align-items: center;
                        div:last-child {
                            padding: 2px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;

                            .span-cs {
                                margin-top: -7px;
                            }

                            .color-span {
                                color: blue;
                            }
                        }
                        span {
                            font-size: 7px;
                        }
                    }
                }
            }
            .last_div {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin-top: 30px;
                .last_item :first{
                    margin: 0px;
                }
                .last_item {
                    width: 100%;
                    height: 256px;
                    .todo-title {
                        color: #36a3f7;
                        font-size: 1.2rem;
                    }
                    .todo-event {
                        display: flex;
                        justify-content: space-between;
                        padding: 30px 20px 10px 10px;
                        width: 100%;
                        p {
                            text-align: center;
                            font-size: 1.4rem;
                            margin: 5px auto,
                        }
                        .red-class {
                            color: red;
                        }
                        span {
                            color: #6f7180;
                            font-size: .9rem;
                        }
                        .last_c {
                            margin-right: 30px;
                        }
                    }
                }
            }
        }

    }

    .mid-div {
        display: flex;
        justify-content: space-between;
        padding: 20px 20px;
        margin-top: 50px;
        .todo-title {
            color: #36a3f7;
            font-size: 1.2rem;
            // padding-top: 15px;
        }
        .profit-statistic {
            .title-select {
                display: flex;
                justify-content: space-between;
            }
        }
    }
</style>
